import { Banner } from "@similarweb/ui-components";

import type { IBannerSitesProps } from "./BannerSites";
import { BannerSites } from "./BannerSites";
import { BannerContainer, StyledSWReactIcons } from "./StyledComponents";

export interface ICommonCompareBannerProps extends Pick<IBannerSitesProps, "domains" | "icons"> {
    title: string;
    buttonText: string;
    onButtonClick: () => void;
}

export const CommonCompareBanner = ({ domains, icons = {}, ...props }: ICommonCompareBannerProps) => (
    <BannerContainer>
        <Banner
            subtitle={
                <BannerSites
                    domains={domains}
                    icons={icons}
                />
            }
            buttonType="primary"
            CustomIcon={<StyledSWReactIcons iconName="ic-keywords" />}
            {...props}
        />
    </BannerContainer>
);